export enum EnumTipoCondicionConcepto {
  NoGarante = 1,
  NoGaranteQd = 2,
  NoGaranteTFijo = 3,
  ElectroIntensivo = 4,
  Socorro = 5,
  Duracion0A3Meses = 6,
  Duracion3A4Meses = 7,
  Duracion4A5Meses = 8,
  Duracion5A6Meses = 9,
  Duracion6A12Meses = 10,
  Autoconsumo = 11
}
